import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../api";
import { TicketOffice } from "../../@types/ticket-office";

export function useTicketOfficeList() {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<Array<TicketOffice>, AxiosError<{ detail: string }>>({
        retry: false,
        enabled: !!token,
        queryKey: ['ticket-office', 'list'],
        queryFn: async () => {
            const response = await apisiseci.get<Array<TicketOffice>>(
                `/cms/guiche/`, { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
    });
}
